import { IUserCalendar } from '@commenda/types/src/user';
import React from 'react';
import CalendarSideNav from './calendar-sidenav';
import CalendarSideNavMobile from './calendar-sidenv-mobile';

const CalendarHOC = ({
  children,
  data,
}: {
  children: React.ReactNode;
  data: IUserCalendar;
}) => {
  return (
    <>
      <CalendarSideNavMobile data={data}>{children}</CalendarSideNavMobile>
      <CalendarSideNav data={data}>{children}</CalendarSideNav>
    </>
  );
};

export default CalendarHOC;
